

export const GetCompanyInfo = (api) => {
  return api.get("/api/v1/CompanyInfo/GetCompanyInfo")
}

export const GetFooter = (api) => {
  return api.get("/api/v1/CompanyInfo/GetFooter")
}

export const GetSuppliersLogo = (api) => {
  return api.get("/api/v1/CompanyInfo/GetSuppliersLogo")
}

export const GetHomeSliderItems = (api) => {
  return api.get("/api/v1/CompanyInfo/GetHomeSliderItems")
}

export const GetNavBarItems = (api) => {
  return api.get(`/api/v1/CompanyInfo/GetNavBarItems`)
}

export const GetRegistrationProfits = (api) => {
  return api.get("/api/v1/CompanyInfo/GetRegistrationProfits")
}